// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__ektED","image":"Card_image__1PkAp","speci":"Card_speci__3_cuV","title":"Card_title__1YUwI","price":"Card_price__gXoyY"};